<div class="flex w-full h-full justify-center">
  <div class="mx-auto mt-28 max-w-96 flex flex-col">
    <h3 class="flex items-center">
      <mat-icon
        svgIcon="warning"
        class="text-red mr-2"></mat-icon
      >Login failed. Please try again.
    </h3>
    <button
      (click)="authService.login()"
      mat-raised-button
      color="primary"
      class="mt-4">
      <mat-icon
        svgIcon="login"
        class="mr-2"></mat-icon>
      Login
    </button>
  </div>
</div>
